/* Biovardi interior: base.js */
(() => {
  'use strict';

  if (window.__bvInteriorBaseReady) return;
  window.__bvInteriorBaseReady = true;

  const path = window.location.pathname.replace(/^\/[a-z]{2}(?:-[a-z]{2})?(?=\/)/i, '');
  const supported = /^(\/products\/|\/collections\/|\/blogs\/|\/pages\/)/.test(path);

  if (!supported) return;

  document.body.classList.add('bv-interior');
  document.documentElement.dataset.bvInterior = 'ready';
})();


/* Biovardi interior: collection.js */
/* Presentation enhancement only. Native Canopy controls remain authoritative. */
(() => {
  'use strict';

  const root = document.documentElement;
  const initAttribute = 'data-bv-collection-init';
  const collectionRoute = /^(?:\/[a-z]{2}(?:-[a-z]{2})?)?\/collections\/([^/]+)\/?$/i;
  const route = window.location.pathname.match(collectionRoute);

  // Collection-scoped product URLs must not acquire collection styling.
  if (!route || root.hasAttribute(initAttribute)) return;
  root.setAttribute(initAttribute, '1');

  const knownFacialIntro = 'Cosmética facial seleccionadaExplora nuestra selección de limpiadores, sérums, cremas, contornos de ojos y aceites faciales de diferentes marcas. Cada producto tiene una formulación, certificaciones y modo de uso propios, por lo que recomendamos consultar su ficha antes de elegir.';
  const compactFacialIntro = 'Limpiadores, sérums, cremas y aceites faciales para elegir tu cuidado con criterio farmacéutico.';
  let observedMain = null;
  let filterObserver = null;
  let filterFrame = 0;

  function createLink(label, href, modifier) {
    const link = document.createElement('a');
    link.className = 'bv-collection-guidance__link';
    if (modifier) link.classList.add(modifier);
    link.href = href;
    link.textContent = label;
    return link;
  }

  function enhanceCollection() {
    const main = document.getElementById('main-content');
    const products = main && main.querySelector('.cc-collection-products');
    if (!document.body || !products) return;

    document.body.classList.add('bv-collection-page');
    setupDesktopFilterState(main);

    const heading = main.querySelector('h1');
    const hero = heading && heading.closest('.cc-collection-banner');
    if (!hero) return;
    hero.classList.add('bv-collection-hero');

    // A facial Skin Test is not a relevant shortcut for hair/body collections.
    if (route[1].toLowerCase() !== 'cosmetica-facial') return;

    const paragraph = hero.querySelector('.rte > p');
    if (paragraph && paragraph.childElementCount === 0) {
      const text = paragraph.textContent.trim().replace(/\s+/g, ' ');
      // Only repair the exact audited text. Future merchant content stays intact.
      if (text === knownFacialIntro) {
        paragraph.textContent = compactFacialIntro;
        paragraph.setAttribute('data-bv-collection-intro', 'compact');
      }
    }

    if (hero.querySelector('[data-bv-collection-guidance]')) return;
    const host = hero.querySelector('.collection-banner__content > div');
    if (!host) return;

    const guidance = document.createElement('nav');
    guidance.className = 'bv-collection-guidance';
    guidance.setAttribute('data-bv-collection-guidance', '');
    guidance.setAttribute('aria-label', 'Elige tu cuidado facial');
    guidance.appendChild(createLink('Skin Test gratis', '/pages/analisis-de-piel'));

    const results = products.querySelector('#filter-results');
    if (results) {
      const currentProductsUrl = () => new URL(
        window.location.pathname + window.location.search + '#filter-results',
        window.location.origin
      ).href;
      const productsLink = createLink('Ver productos', currentProductsUrl(), 'bv-collection-guidance__link--products');
      // Keep both the current origin (including local previews with <base>) and
      // any filters changed by Canopy since this link was first rendered.
      productsLink.addEventListener('click', () => {
        productsLink.href = currentProductsUrl();
      });
      guidance.appendChild(productsLink);
    }
    host.appendChild(guidance);
  }

  function setupDesktopFilterState(main) {
    function sync() {
      filterFrame = 0;
      const currentMain = document.getElementById('main-content');
      if (!currentMain) return;
      const desktop = window.matchMedia('(min-width: 1024px)').matches;
      currentMain.querySelectorAll('.cc-collection-products .main-products-grid__filters').forEach((filters) => {
        const facets = filters.querySelector('facet-filters.facets');
        if (!facets) return;
        if (!desktop) {
          if (facets.hasAttribute('data-bv-desktop-facets')) {
            facets.setAttribute('role', 'dialog');
            facets.setAttribute('aria-modal', 'true');
            facets.removeAttribute('data-bv-desktop-facets');
          }
          return;
        }
        const open = !filters.classList.contains('lg:js-hidden');
        facets.setAttribute('data-bv-desktop-facets', open ? 'open' : 'closed');
        facets.setAttribute('aria-hidden', String(!open));
        facets.setAttribute('role', open ? 'region' : 'dialog');
        facets.setAttribute('aria-modal', open ? 'false' : 'true');
      });
    }

    function schedule() {
      if (filterFrame) return;
      filterFrame = window.requestAnimationFrame(sync);
    }

    function observeCurrentMain() {
      const currentMain = document.getElementById('main-content');
      if (currentMain && currentMain !== observedMain) {
        filterObserver?.disconnect();
        observedMain = currentMain;
        filterObserver = new MutationObserver(schedule);
        filterObserver.observe(currentMain, {
          subtree: true,
          childList: true,
          attributes: true,
          attributeFilter: ['class']
        });
      }
      schedule();
    }

    if (!root.hasAttribute('data-bv-collection-filter-sync')) {
      root.setAttribute('data-bv-collection-filter-sync', '1');
      window.addEventListener('resize', observeCurrentMain, { passive: true });
      window.__bvCollectionFilterSync = observeCurrentMain;
    }

    if (main !== observedMain) observeCurrentMain();
    else schedule();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhanceCollection, { once: true });
  } else {
    enhanceCollection();
  }

  // Rebuild only the small intro enhancement when Theme Editor replaces a section.
  // Product/filter AJAX updates need no handler: their native DOM inherits the CSS.
  document.addEventListener('shopify:section:load', enhanceCollection);
})();


/* Biovardi interior: product.js */
/* Biovardi / Canopy main-product enhancement. No API requests or second form.
   Load deferred with product.css. Clicks go through the current native add button. */
(() => {
  'use strict';

  const key = '__bvProductLuxe';
  if (window[key]) return;
  const controllers = new Map();
  const sectionSelector = 'main .cc-main-product';
  const clean = (value) => (value || '').replace(/\s+/g, ' ').trim();
  const setAttribute = (node, name, value) => {
    if (node.getAttribute(name) !== String(value)) node.setAttribute(name, String(value));
  };
  const productRoute = () => /(?:^|\/)products\/[^/]+\/?$/.test(window.location.pathname);
  const reducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Canopy prints cents in <sup>; textContent alone would turn EUR 198.90 into 19890.
  // Keep the native currency/locale text and insert only its decimal separator.
  function priceText(price) {
    if (!price) return '';
    const copy = price.cloneNode(true);
    let decimal = ',';
    try {
      decimal = new Intl.NumberFormat(document.documentElement.lang || 'es')
        .formatToParts(1.1).find((part) => part.type === 'decimal').value;
    } catch (_) { /* The live store's fallback locale is Spanish. */ }
    copy.querySelectorAll('sup').forEach((sup) => {
      const previous = sup.previousSibling ? sup.previousSibling.textContent : '';
      const separator = /[.,]\s*$/.test(previous) ? '' : decimal;
      sup.replaceWith(document.createTextNode(separator + clean(sup.textContent)));
    });
    copy.querySelectorAll('.visually-hidden, [aria-hidden="true"]').forEach((node) => node.remove());
    return clean(copy.textContent);
  }

  function setup(section) {
    if (controllers.has(section)) return;
    let frame = 0;
    let panel = null;
    let proxy = null;
    let priceSignature = '';
    let priceTarget = null;
    let sending = false;
    let destroyed = false;

    const nativeButton = () => section.querySelector(
      '.product-info form.js-product-form-main [name="add"]'
    );

    const state = () => {
      const button = nativeButton();
      const form = button && button.form;
      const variant = form && form.elements.namedItem('id');
      const busy = Boolean(button && (
        button.classList.contains('is-loading') ||
        button.getAttribute('aria-busy') === 'true' ||
        (form && form.getAttribute('aria-busy') === 'true')
      ));
      const unavailable = !button || !form || !variant || !variant.value || variant.disabled ||
        button.matches(':disabled') || button.getAttribute('aria-disabled') === 'true';
      const label = busy ? 'Añadiendo…' : clean(button && button.textContent) ||
        (button && button.dataset.addToCartText) || 'No disponible';
      return { button, form, busy, unavailable, label };
    };

    function reveal(node) {
      if (!node) return;
      node.scrollIntoView({ behavior: reducedMotion() ? 'auto' : 'smooth', block: 'center' });
      if (!node.matches('button, input, select, textarea, a[href], [tabindex]')) {
        node.setAttribute('tabindex', '-1');
      }
      node.focus({ preventScroll: true });
    }

    function activate(event) {
      event.preventDefault();
      const current = state();
      if (sending || current.busy || current.unavailable) {
        sync();
        return;
      }
      sending = true;
      try {
        // Never reconstruct FormData: native quantity, variant, properties and
        // selling-plan inputs, validation, cart drawer and errors stay native.
        current.button.click();
      } finally {
        sending = false;
        sync();
      }
    }

    function ensurePanel() {
      panel = section.querySelector('sticky-atc-panel');
      if (!panel) return false;
      const buttons = panel.querySelector('.card__buttons');
      if (!buttons) return false;
      let nextProxy = buttons.querySelector('button.bv-product-sticky-action');
      if (!nextProxy) {
        // Only replace the audited jump link, never an app or a second form.
        const anchor = buttons.querySelector('a[href="#product-info"]');
        if (!anchor) return false;
        nextProxy = document.createElement('button');
        nextProxy.type = 'button';
        nextProxy.className = 'bv-product-sticky-action';
        anchor.replaceWith(nextProxy);
      }
      if (proxy !== nextProxy) {
        proxy = nextProxy;
        proxy.addEventListener('click', activate);
      }
      setAttribute(panel, 'data-bv-product-sticky', '');
      return true;
    }

    function sync() {
      if (destroyed || !section.isConnected || !ensurePanel()) return;
      const current = state();
      const title = clean(section.querySelector('.product-info h1')?.textContent);
      const sourcePrice = section.querySelector('.product-info .product-info__price .price');
      const sourceCurrent = sourcePrice && sourcePrice.querySelector('.price__current');
      const readablePrice = priceText(sourceCurrent);
      const info = panel.querySelector('.card__info');
      const heading = panel.querySelector('.sticky-atc-panel__heading');
      if (heading && title && clean(heading.textContent) !== title) heading.textContent = title;

      // Clone presentation from the live native price; no snapshot, calculation
      // or hard-coded variant/price. Preserve compare-at and unit-price markup.
      if (sourcePrice && info) {
        const oldPrice = info.querySelector('.price');
        if (!oldPrice || priceTarget !== oldPrice || priceSignature !== sourcePrice.outerHTML) {
          const copy = sourcePrice.cloneNode(true);
          copy.removeAttribute('id');
          copy.querySelectorAll('[id]').forEach((node) => node.removeAttribute('id'));
          if (oldPrice) oldPrice.replaceWith(copy);
          else info.append(copy);
          priceSignature = sourcePrice.outerHTML;
          priceTarget = copy;
        }
      } else if (info) {
        info.querySelector('.price')?.remove();
        priceSignature = '';
        priceTarget = null;
      }

      if (proxy.textContent !== current.label) proxy.textContent = current.label;
      const disabled = Boolean(current.unavailable || current.busy || sending);
      if (proxy.disabled !== disabled) proxy.disabled = disabled;
      setAttribute(proxy, 'aria-disabled', proxy.disabled);
      setAttribute(proxy, 'aria-busy', current.busy);
      const quantity = current.form && current.form.elements.namedItem('quantity');
      const detail = [title, readablePrice, quantity && `Cantidad: ${quantity.value}`]
        .filter(Boolean).join(' · ');
      setAttribute(proxy, 'aria-label', `${current.label}${detail ? ': ' + detail : ''}`);
      if (current.form && current.form.id) setAttribute(proxy, 'aria-controls', current.form.id);

      const header = document.querySelector('.cc-header--sticky');
      const headerBottom = header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
      const passedButton = current.button && current.button.getClientRects().length > 0 &&
        current.button.getBoundingClientRect().bottom <= headerBottom;
      const focused = panel.contains(document.activeElement);
      // Leave the page's final links reachable, as Canopy's original panel does.
      // Do not hide a focused keyboard control before its user leaves it.
      const atPageEnd = Math.ceil(window.scrollY + window.innerHeight) >=
        document.documentElement.scrollHeight - 40;
      const visible = Boolean(current.button && ((passedButton && !atPageEnd) || focused));
      setAttribute(panel, 'data-bv-sticky-visible', visible);
      setAttribute(panel, 'aria-hidden', !visible);
      panel.inert = !visible;
      // Native hidden styles are overridden only when these scoped markers exist.
      // When invisible, remove the control from keyboard order in older browsers.
      proxy.tabIndex = visible ? 0 : -1;
    }

    function schedule() {
      if (frame || destroyed) return;
      frame = window.requestAnimationFrame(() => {
        frame = 0;
        sync();
      });
    }

    function onError(event) {
      if (!section.contains(event.target)) return;
      schedule();
      const error = section.querySelector('.product-info .js-form-error:not([hidden])');
      if (error) reveal(error);
    }

    // Variant changes may replace the price, add button and entire sticky panel.
    // Observe just this section and coalesce reads/writes to one animation frame.
    const observer = new MutationObserver(schedule);
    observer.observe(section, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['disabled', 'aria-disabled', 'aria-busy', 'class', 'value', 'hidden']
    });
    section.addEventListener('change', schedule);
    section.addEventListener('input', schedule);
    section.addEventListener('focusout', schedule);
    section.addEventListener('on:cart:error', onError);
    document.addEventListener('on:variant:change', schedule);
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    window.addEventListener('pageshow', schedule);

    controllers.set(section, () => {
      destroyed = true;
      observer.disconnect();
      window.cancelAnimationFrame(frame);
      section.removeEventListener('change', schedule);
      section.removeEventListener('input', schedule);
      section.removeEventListener('focusout', schedule);
      section.removeEventListener('on:cart:error', onError);
      document.removeEventListener('on:variant:change', schedule);
      window.removeEventListener('scroll', schedule);
      window.removeEventListener('resize', schedule);
      window.removeEventListener('pageshow', schedule);
      controllers.delete(section);
    });
    sync();
  }

  function boot() {
    if (!productRoute()) return;
    const sections = document.querySelectorAll(sectionSelector);
    if (!sections.length) return;
    document.body.classList.add('bv-template-product');
    sections.forEach(setup);
  }

  window[key] = { version: '1.0.0' };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else boot();
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:section:unload', (event) => {
    for (const [section, destroy] of controllers) {
      if (section === event.target || event.target.contains(section)) destroy();
    }
  });
})();


/* Biovardi interior: editorial.js */
/* Biovardi editorial enhancement. Load once with defer, after editorial.css.
 * Activates only on the audited Spanish routes and matching native sections.
 * No requests, tracking, cart code, form submission or quiz state changes.
 */
(function () {
  'use strict';

  var READY = 'data-bv-editorial-initialized';
  var BLOG = '/blogs/cosmetica-natural';
  var PORTRAIT_ALT = 'Souad Charifi, farmacéutica y fundadora de Biovardi en Marbella';

  function text(element) {
    return element ? element.textContent.trim() : '';
  }

  function classify(main) {
    var path = window.location.pathname.replace(/\/+$/, '');
    var lang = document.documentElement.lang.toLowerCase();
    if (lang && lang !== 'es' && lang.indexOf('es-') !== 0) return '';
    if ((path === BLOG || path.indexOf(BLOG + '/tagged/') === 0) &&
        main.querySelector('.cc-main-blog')) return 'blog';
    if (path.indexOf(BLOG + '/') === 0 &&
        main.querySelector('.cc-main-article article.article .article__content')) return 'article';
    if (path === '/pages/quienes-somos' &&
        main.querySelector('.cc-main-page .page__content')) return 'about';
    if (path === '/pages/analisis-de-piel' &&
        main.querySelector('.cc-main-page #bv-quiz #bv-stage')) return 'skin';
    return '';
  }

  function prepareTopics(main) {
    var list = main.querySelector('.cc-main-blog blog-filter #blog-filter-links');
    if (!list || list.tagName !== 'UL' || list.hasAttribute('data-bv-topics-ready')) return;
    var host = list.parentElement;
    // The native desktop-only wrapper also hides our button on mobile.
    if (!host || !host.classList.contains('hidden') || !host.classList.contains('md:block')) return;
    var links = Array.prototype.slice.call(list.querySelectorAll('a[href]'));
    // A local preview may use the live shop as its base for native assets/links.
    var baseOrigin = new URL(document.baseURI).origin;
    if (links.length < 10 || !links.every(function (link) {
      var path = link.pathname.replace(/\/+$/, '');
      return (link.origin === window.location.origin || link.origin === baseOrigin) &&
        (path === BLOG || path.indexOf(BLOG + '/tagged/') === 0);
    })) return;

    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'bv-editorial-topics-toggle';
    button.setAttribute('aria-controls', list.id);
    var isOpen = false;
    function render() {
      button.setAttribute('aria-expanded', String(isOpen));
      button.textContent = isOpen ? 'Ocultar temas' : 'Mostrar temas';
      list.hidden = !isOpen;
    }
    button.addEventListener('click', function () {
      isOpen = !isOpen;
      render();
    });
    // Existing filter links and their event handlers remain in place.
    list.classList.add('bv-editorial-topics');
    host.classList.add('bv-editorial-topics-host');
    host.insertBefore(button, list);
    list.setAttribute('data-bv-topics-ready', 'true');
    render();
  }

  function localizeNewsletter(main) {
    main.querySelectorAll('.cc-newsletter .newsletter').forEach(function (section) {
      var heading = section.querySelector('h2.section__block--heading');
      var paragraph = section.querySelector('.section__block.rte > p');
      // A merchant edit or a different locale must never be overwritten.
      if (!heading || !paragraph || heading.children.length || paragraph.children.length ||
          text(heading) !== 'Subscribe to our emails' ||
          text(paragraph) !== 'Be the first to know about new collections and exclusive offers.') return;
      heading.textContent = 'Recibe nuestras novedades';
      paragraph.textContent = 'Descubre antes que nadie nuestras nuevas colecciones y ofertas exclusivas.';
      section.setAttribute('data-bv-newsletter-localized', 'true');
    });
  }

  function prepareAbout(main) {
    var content = main.querySelector('.cc-main-page .page__content');
    if (!content) return;
    var plainHeadings = {
      'QUÉ ES BIOVARDI': 'Qué es Biovardi',
      'LA HISTORIA DETRÁS DE BIOVARDI': 'La historia detrás de Biovardi'
    };
    content.querySelectorAll('h2').forEach(function (heading) {
      if (!heading.children.length && plainHeadings[text(heading)]) {
        heading.textContent = plainHeadings[text(heading)];
      }
    });
    if (content.querySelector('.bv-editorial-about-intro')) return;
    var portraits = Array.prototype.filter.call(content.querySelectorAll('img'), function (img) {
      return img.alt === PORTRAIT_ALT;
    });
    if (portraits.length !== 1) return;
    var portrait = portraits[0];
    var story = portrait.parentElement;
    var copy = story && story.parentElement;
    // Only the exact, unlinked image in the audited paragraph-only story.
    if (!copy || copy.parentElement !== content || story.tagName !== 'DIV' ||
        story.firstElementChild !== portrait || portrait.closest('a, picture, figure, button') ||
        story.children.length !== 4 ||
        !Array.prototype.slice.call(story.children, 1).every(function (node) { return node.tagName === 'P'; })) return;
    var imageUrl;
    try { imageUrl = new URL(portrait.getAttribute('src'), window.location.href); } catch (error) { return; }
    if (imageUrl.hostname !== 'cdn.shopify.com' ||
        imageUrl.pathname !== '/s/files/1/0273/2005/7991/files/IMG_7591.jpg' ||
        imageUrl.searchParams.get('v') !== '1753181654') return;
    var heading = copy.firstElementChild;
    var first = heading && heading.nextElementSibling;
    var second = first && first.nextElementSibling;
    var following = second && second.nextElementSibling;
    if (!heading || heading.tagName !== 'H2' || text(heading) !== 'Qué es Biovardi' ||
        !first || first.tagName !== 'P' || !second || second.tagName !== 'P' ||
        !following || following.tagName !== 'H2' ||
        text(first).indexOf('Biovardi es una parafarmacia fundada en Marbella en 2012 por Souad Charifi') !== 0) return;

    var intro = document.createElement('div');
    intro.className = 'bv-editorial-about-intro';
    var introCopy = document.createElement('div');
    introCopy.className = 'bv-editorial-about-copy';
    var figure = document.createElement('figure');
    figure.className = 'bv-editorial-founder';
    copy.insertBefore(intro, heading);
    intro.appendChild(introCopy);
    intro.appendChild(figure);
    introCopy.appendChild(heading);
    introCopy.appendChild(first);
    introCopy.appendChild(second);
    figure.appendChild(portrait);
    // Dimensions verified for this versioned file; preserve its full portrait.
    if (!portrait.hasAttribute('width')) portrait.setAttribute('width', '1800');
    if (!portrait.hasAttribute('height')) portrait.setAttribute('height', '4000');
  }

  function prepareSkin(main) {
    var heading = main.querySelector('#bv-quiz #bv-stage h2');
    if (heading && !heading.children.length && text(heading) === 'Análisis de piel con IA') {
      heading.textContent = 'Descubre qué necesita tu piel';
    }
  }

  function initialize() {
    var main = document.querySelector('main#main-content, main#MainContent');
    if (!main || !document.body) return;
    var type = classify(main);
    if (!type) return;
    document.body.setAttribute('data-bv-editorial', type);
    if (type === 'blog') prepareTopics(main);
    if (type === 'about') prepareAbout(main);
    if (type === 'skin') prepareSkin(main);
    localizeNewsletter(main);
  }

  // A theme-editor section refresh may safely repeat the DOM checks.
  if (document.documentElement.hasAttribute(READY)) return;
  document.documentElement.setAttribute(READY, 'true');
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
  document.addEventListener('shopify:section:load', initialize);
}());
